import { ConsumablesMatrixData } from "@jti/product-details";

import { createSafeContentWithData } from "../builder/tools/createSafeContentWithData/createSafeContentWithData";

const {
  Content: ConsumablesProductContent,
  createDefaultDataBindings: createConsumablesProductDefaultDataBinding,
} = createSafeContentWithData<{
  productSku: string;
  productBadgeText: string;
  productDescription: string;
  productShortDescription: string;
  productKnowMoreUrl: string;
  productMultiPackDescription: string;
  productCta: { label: string; url: string };
  productName: string;
  productIsCommerceDisabled: boolean;
  productIsMultiPackEnabled: boolean;
  productMultiPackName: string;
  productMultiPackProducts: string[];
  productCustomBuyCtaLabel: string;
  productConsumablesMatrixData: ConsumablesMatrixData;
  productIsSubscriptionsEnabled: boolean;
}>();

export {
  ConsumablesProductContent,
  createConsumablesProductDefaultDataBinding,
};
